import type { IconSvgObject } from './types';

const ChimneyIcon: IconSvgObject = [
  ["path", { d: "M15.5 22L14.5 17C13.9128 14.3576 13.5 10.7066 13.5 7.99976H6.5C6.5 11 6.0872 14.3576 5.5 17L4.5 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 22H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 2H13C11.3431 2 10 3.34315 10 5M20 2H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M13 5H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ChimneyIcon;
